var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 508,
    height: 850,
    viewBox: "0 0 508 850",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M105.822 103.156C62.4111 103.156 27.0938 133.344 27.0938 170.46V759.54C27.0938 796.656 62.4111 826.844 105.822 826.844H402.172C445.578 826.844 480.895 796.656 480.895 759.54V170.46C480.895 133.344 445.578 103.156 402.172 103.156H105.822ZM402.172 850H105.822C47.4723 850 0 809.42 0 759.54V170.46C0 120.58 47.4723 80 105.822 80H402.172C460.524 80 508 120.58 508 170.46V759.54C508 809.42 460.524 850 402.172 850Z",
    fill: "#484D4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308.634 94.8672H199.397C186.748 94.8672 176.398 84.5072 176.398 71.8672V48.8672C176.398 21.9872 198.39 0.000515886 225.268 0.000515886H282.764C309.642 0.000515886 331.633 21.9872 331.633 48.8672V71.8672C331.633 84.5072 321.285 94.8672 308.634 94.8672Z",
    fill: "#484D4D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M404.32 793.109H101.455C74.9348 793.109 53.4375 771.603 53.4375 745.083V694.309H452.332V745.083C452.332 771.603 430.839 793.109 404.32 793.109Z",
    fill: "#228B22"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M452.332 657.254H53.4375V558.467H452.332V657.254Z",
    fill: "#228B22"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M452.332 521.414H53.4375V422.614H452.332V521.414Z",
    fill: "#228B22"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M454.599 381.707H55.6953V282.907H454.599V381.707Z",
    fill: "#228B22"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M454.599 245.867H55.6953V147.067H454.599V245.867Z",
    fill: "#228B22"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.05d2b136fc2e611ee9641e561bc04279.svg";
export { ForwardRef as ReactComponent };